import AddIcon from "@mui/icons-material/Add";
import { Fab, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    zIndex: theme.zIndex.drawer - 1,
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

function Page(props) {
  const { onClickNewButton } = props;
  let pageHeight = "100%";
  const classes = useStyles();

  return (
    <Grid
      container
      alignContent="flex-start"
      justifyContent="center"
      style={{ minHeight: pageHeight, overflow: "auto" }}
    >
      {props.children}
      {onClickNewButton && (
        <Fab
          aria-label="neu"
          className={classes.fab}
          color="primary"
          onClick={onClickNewButton}
        >
          <AddIcon />
        </Fab>
      )}
      <Grid item xs={12}>
        {onClickNewButton && <div style={{ height: "64px" }}></div>}
      </Grid>
      <div className="ectool-safe-area-bottom"></div>
    </Grid>
  );
}

const PageLayout = ({ header, content, footer }) => {
  let pageHeight = String(window.innerHeight - 65) + "px";
  return (
    <Grid
      container
      alignContent="stretch"
      justifyContent="center"
      style={{ height: "100%"}}
      flexDirection={"column"}
      flexWrap={"nowrap"}
      width={"100%"}
    >
      <Grid item>{header}</Grid>
      <Grid item flexGrow={1} overflow={"auto"}>
        {content}
      </Grid>
      <Grid item>{footer}</Grid>
    </Grid>
  );
};

export default Page;
export { PageLayout };

